import React from "react";
import { Alert, Box, CircularProgress } from "@mui/material";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PLATFORM_CONSOLE_SECTION_PATH } from "./platformConsoleRoutes";
import { PLATFORM_CONSOLE_GOVERNANCE_SECTION_ORDER, usePlatformConsoleAcl } from "./PlatformConsoleAclContext";
import PlatformConsoleNoAccess from "./PlatformConsoleNoAccess";

function firstNavigableSectionPath(can) {
  for (const key of PLATFORM_CONSOLE_GOVERNANCE_SECTION_ORDER) {
    if (can(key, "view")) {
      const path = PLATFORM_CONSOLE_SECTION_PATH[key];
      if (path) return path;
    }
  }
  return null;
}

/**
 * Bloqueia rota do console quando o master não tem permissão na seção.
 */
export default function PlatformConsoleSectionGate({ section, action = "view", children }) {
  const { t } = useTranslation("app");
  const { loading, can } = usePlatformConsoleAcl();

  if (loading) {
    return (
      <Box sx={{ py: 6, display: "flex", justifyContent: "center" }} role="status" aria-live="polite">
        <CircularProgress size={32} />
      </Box>
    );
  }

  if (!can(section, action)) {
    const fallback = firstNavigableSectionPath(can);
    if (fallback) {
      return (
        <Box sx={{ py: 2 }}>
          <Alert severity="warning" sx={{ mb: 2 }}>
            {t("platformPage.sectionAccessDenied")}
          </Alert>
          <Navigate to={fallback} replace />
        </Box>
      );
    }
    return <PlatformConsoleNoAccess />;
  }

  return children;
}
